import {gsap} from "gsap";
import App from "@templates/App/App.js";
import Floor from "../../Floor/Floor.js";
import Building from "../Building.js";
import FloorBuilding from "../../Floor/FloorBuilding/FloorBuilding.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";

const BuildingBubble = {
    min: 0,
    max: 20,
    init(el) {
        this.el = el.find('[element="bubble"]');
        if (!this.el.length) return;

        this.button = this.el.find('.button');
        this.arrows = this.el.find('.arrows a');
        this.bind();
    },

    bind() {
        this.button.unbind('click').click((evt) => {
            const nmb = parseInt($(evt.currentTarget).attr('id'));
            NavigatorRouter.setFloor(nmb);
            this.hide();
        })

        this.arrows.unbind('click').click((evt) => {
            const shift = parseInt($(evt.currentTarget).attr('shift'));
            this.shift(shift);
        })
    },

    shift(shift) {
        Floor.number = Floor.number + shift;

        if (Floor.number < this.min) {
            Floor.number = this.min;
        }
        if (Floor.number > this.max) {
            Floor.number = this.max;
        }

        const floor = Building.floors.filter('[id="' + Floor.number + '"]');
        floor.trigger('click');

        this.arrangeButtons();
    },

    arrangeButtons() {
        this.arrows.removeClass('disabled');
        // console.log(Floor.number, this.min, Floor.number >= this.min, this.arrows.filter('.up'))

        if (Floor.number >= this.max) {
            this.arrows.filter('.up').addClass('disabled');
        }
        if (Floor.number <= this.min) {
            this.arrows.filter('.down').addClass('disabled');
        }
    },

    show(data, floor, evt) {
        // if (!data) {
        //     this.hide();
        //     return;
        // }

        this.prepare(data, floor, evt);
        if(this.debug) console.log('show', data, floor)
        this.set();
        this.arrangeButtons();
        if (!App.isDesktop) this.scroll();
        if (App.isDesktop) this.move(floor, evt);
    },

    prepare(data, floor, evt) {
        if(this.debug) console.log('prepare', data, floor);
        this.data = data;
        this.inflect();
        this.prepareArrowPosition();
        this.prepareTexts();
        this.button.attr('id', this.data.number);
    },

    move(floor, evt) {
        // console.log(this.el)
        const id = parseInt($(floor).attr('id'));

        const floorH = (floor.getBoundingClientRect().height / 2);
        const floorW = (floor.getBoundingClientRect().width / 2);
        let top = 0
        let left = 0;
        let bulgarianConstant = 0;

        if(this.debug) console.log('move', floorH, floorW, this.data.type)

        if (this.data.type === 'medicalFloor') {
            top = $(floor).offset().top + floorH;
            left = $(floor).offset().left;

        }else if (this.data.type === 'flat' || this.data.type === 'apartment') {
            bulgarianConstant = (id * 3);
            top = $(floor).offset().top + floorH + bulgarianConstant;
            left = $(floor).offset().left;

        } else if(this.data.type === 'medical'){
            top = $(floor).offset().top;
            left = $(floor).offset().left + (floorW * 2.1);

        } else if(this.data.type === 'shop'){
            top = $(floor).offset().top;
            left = $(floor).offset().left + (floorW * 1.4);
        }

        if (evt.type === 'click' && (this.data.type === 'flat' || this.data.type === 'apartment')) {
            top = evt.clientY;
        }

        gsap.to(this.el, {left: left, top: top, duration: 0.2});
    },


    scroll() {
        let shift, top;

        if (this.data.type === 'flat' || this.data.type === 'apartment') {
            shift = App.isMobile ? 0.50 : 0.42;
            if (App.isTablet) top = 300;
            if (App.isMobile) top = 120;
        } else if (this.data.type === 'medical') {
            shift = 0.36;
            if (App.isTablet) top = '40%';
            if (App.isMobile) top = '30%';
        } else if (this.data.type === 'shop') {
            shift = 0.44;
            if (App.isTablet) top = '50%';
            if (App.isMobile) top = '40%';
        } else {
            shift = 0.58;
        }

        BannerParallax.scrollTo(shift);
        const left = Building.canvas.find('.scene').outerWidth() * shift + 20;
        gsap.to(this.el, {top: top, left: left, duration: 0.5});
    },

    set() {

        this.el.attr('class', this.arrowPosition + ' ' + this.data.type);
        this.el.find('h3').html(this.data.title);

        this.el.toggleClass('empty', this.data.flats_free === 0);

        if (this.data.text) {
            this.el.find('p').show().html(this.data.text);
        } else {
            this.el.find('p').hide();
        }

        gsap.to(this.el, {opacity: 1, duration: 0.5});
    },

    hide() {
        gsap.to(this.el, {opacity: 0, duration: 0.5});
    },

    inflect() {
        const free = this.data.flats_free;
        this.data.count = free + ' voľných<br>';
        this.data.apartment = ' nebytových priestorov';
        this.data.flat = ' bytov a apartmánov';
        this.data.nonresidental = ' nebytových priestorov';

        if (free === 0) {
            this.data.count = 'Žiadne voľné<br>';
            this.data.apartment = ' nebytové priestory';
            this.data.flat = ' byty a apartmány';
            this.data.nonresidental = ' nebytových priestorov';
        } else if (free === 1) {
            this.data.count = free + ' voľný<br>';
            this.data.apartment = ' nebytový priestor';
            this.data.flat = ' byt alebo apartmán';
            this.data.nonresidental = ' nebytový priestor';

        } else if (free >= 2 && free <= 4) {
            this.data.count = free + ' voľné<br>';
            this.data.apartment = ' nebytové priestory';
            this.data.flat = ' byty a apartmány';
            this.data.nonresidental = ' nebytové priestory';
        }
    },

    prepareArrowPosition() {

        if (this.data.type === 'medicalFloor') {
            if (App.isMobile) {
                this.arrowPosition = 'bc';
            } else {
                if (this.data.number > 1) {
                    this.arrowPosition = 'lt';
                } else {
                    this.arrowPosition = 'bc';
                }
            }

        } else {
            if (!App.isDesktop) {
                this.arrowPosition = '';
                // if (this.data.number > 10) {
                //     this.arrowPosition = 'rt';
                // } else if (this.data.number < 10 && this.data.number > 1) {
                //     this.arrowPosition = 'rb';
                // } else if (this.data.number === 1) {
                //     this.arrowPosition = 'bl';
                // } else if (this.data.number === 0) {
                //     this.arrowPosition = 'bl';
                // }
            } else {
                if (this.data.number > 1) {
                    this.arrowPosition = 'rt';
                } else if (this.data.number === 1) {
                    this.arrowPosition = 'bc';
                } else if (this.data.number === 0) {
                    this.arrowPosition = 'bl';
                }
            }
        }

    },

    prepareTexts() {
        switch (this.data.type) {
            case 'flat': {
                this.data.title = this.data.number + '.&nbsp;podlažie';

                if (this.data.number <= 5) {
                    this.data.text = this.data.count + this.data.nonresidental;
                } else {
                    this.data.text = this.data.count + this.data.flat;
                }
                // this.data.text = "Pripravujeme<br>pre Vás"
                break;
            }
            case 'apartment': {
                this.data.title = this.data.number + '.&nbsp;podlažie';
                // this.data.text = "Pripravujeme<br>pre Vás"
                this.data.text = this.data.count + this.data.apartment;
                break;
            }
            case 'shop': {
                this.data.title = 'Obchodné<br>priestory';
                this.data.text = "Priestory o&nbsp;výmere<br>od&nbsp;13,49&nbsp;m<sup>2</sup> do&nbsp;153,42&nbsp;m<sup>2</sup>"
                break;
            }
            case 'medical': {
                this.data.title = 'Zdravotnícke<br>zariadenie';
                this.data.text = "Päť podlaží o výmere<br>od 2897&nbsp;m<sup>2</sup>"
                break;
            }
            case 'medicalFloor': {
                this.data.title = this.data.number + '.&nbsp;podlažie';
                this.data.text = 'Celková výmera:<br>' + this.data.total_space + ' m<sup>2</sup>';
                break;
            }
            default: {
                break;
            }
        }
    },
}

export default BuildingBubble;